import React from "react";
import { useNavigate } from "react-router-dom";

export default function BillingRequired() {
  const navigate = useNavigate();

  const container = {
    padding: 40,
    textAlign: "center",
  };

  const card = {
    maxWidth: 500,
    margin: "0 auto",
    background: "#13293d",
    borderRadius: 12,
    padding: 30,
    border: "1px solid rgba(255,255,255,0.08)",
  };

  const button = {
    marginTop: 20,
    padding: "12px 18px",
    background: "#e0b84f",
    border: "none",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 700,
    color: "#0b1b2b",
  };

  return (
    <div style={container}>
      <div style={card}>
        <h2>Your Trial Has Expired</h2>

        <p style={{ color: "#9fb0c3", marginTop: 10 }}>
          Your JobTelesis workspace is currently inactive.
        </p>

        <p style={{ color: "#9fb0c3" }}>
          To continue using your account, please select a plan and add a payment method.
        </p>

        <button style={button} onClick={() => navigate("/billing")}>
          Upgrade / Choose Plan
        </button>
      </div>
    </div>
  );
}
